var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9826 19.8952C21.9091 19.8475 21.356 19.46 20.8022 18.2879C19.7852 16.1355 19.5717 13.1033 19.5717 10.9387C19.5717 10.9293 19.5715 10.92 19.5711 10.9106C19.5601 8.0498 17.847 5.58369 15.3957 4.4772V2.78496C15.3957 1.24932 14.1484 0 12.6153 0H12.3849C10.8518 0 9.6045 1.24932 9.6045 2.78496V4.4771C7.14493 5.58716 5.42847 8.06587 5.42847 10.9387C5.42847 13.1033 5.215 16.1354 4.19795 18.2879C3.64419 19.46 3.09112 19.8474 3.01758 19.8952C2.70792 20.0385 2.55523 20.3695 2.62647 20.705C2.69839 21.0438 3.01509 21.2774 3.36094 21.2774H8.72945C8.75943 23.3351 10.4388 25 12.5001 25C14.5614 25 16.2408 23.3351 16.2708 21.2774H21.6393C21.9851 21.2774 22.3018 21.0438 22.3737 20.705C22.4449 20.3695 22.2922 20.0384 21.9826 19.8952ZM11.0694 2.78496C11.0694 2.05835 11.6595 1.46724 12.3849 1.46724H12.6153C13.3407 1.46724 13.9309 2.05835 13.9309 2.78496V4.00161C13.4686 3.90605 12.99 3.85576 12.4999 3.85576C12.01 3.85576 11.5315 3.90601 11.0694 4.00146V2.78496H11.0694ZM12.5001 23.5328C11.2465 23.5328 10.224 22.5261 10.1943 21.2775H14.8059C14.7762 22.526 13.7537 23.5328 12.5001 23.5328ZM15.4493 19.8102C15.4492 19.8102 5.03013 19.8102 5.03013 19.8102C5.15684 19.6127 5.2858 19.3891 5.41397 19.1364C6.39561 17.2007 6.89336 14.4426 6.89336 10.9387C6.89336 7.84219 9.40845 5.323 12.4999 5.323C15.5913 5.323 18.1064 7.84219 18.1064 10.9412C18.1064 10.9502 18.1065 10.9592 18.1068 10.9682C18.1096 14.458 18.6073 17.2062 19.5862 19.1364C19.7144 19.3892 19.8434 19.6127 19.9701 19.8102H15.4493Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.a83730cb2b022fdd39bce55d0e592d27.svg";
export { ForwardRef as ReactComponent };